// Tiny slug helper used to derive a stable category key from a human label.
// Lowercases, strips diacritics and spaces, drops anything that isn't a-z/0-9.
// Examples:
//   "Athletes"          -> "athletes"
//   "VIP Guests"        -> "vipguests"
//   "Acompañantes"      -> "acompanantes"
export const slugify = (text: string): string =>
  text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/[^a-z0-9_-]/g, '');
